'use client';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { Container } from '@/components';

import styles from './loanUsesInner.module.scss';
import { LoanUsesCards, LoanUsesContent } from '.';
import { useVisible } from '@/hooks';

interface LoanUsesDefaultProps {
  data: Simplify<Content.LoanUsesSliceDefaultPrimary>;
}

export const LoanUsesDefault = ({ data }: LoanUsesDefaultProps) => {
  const [isVisible, id] = useVisible();
  return (
    <Container styles={styles.container} id={id}>
      <LoanUsesCards cards={data.cards} isVisible={isVisible} />
      <LoanUsesContent
        title={data.title}
        subtitle={data.subtitle}
        button={{ text: data.button_text, link: data.button_link }}
        isVisible={isVisible}
      />
    </Container>
  );
};
